import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=d2ec6fc4&"
import script from "./RegionPicker.vue?vue&type=script&lang=js&"
export * from "./RegionPicker.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/region-picker.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports